import { useNavigate } from "react-router-dom";
import { useEffect, ReactNode } from "react";
import { useAuth } from "../../../contexts/authContext";

interface WithAuthProtectionProps {
  children: ReactNode;
  allowedRoles?: string[];
}

export default function WithAuthProtection({
  children,
  allowedRoles = [],
}: WithAuthProtectionProps) {
  const navigate = useNavigate();

  const { role } = useAuth();

  useEffect(() => {
    if (!role) {
      navigate("/auth/sign-in", {
        replace: true,
      });
      return;
    }

    if (
      allowedRoles.length < 0 &&
      !allowedRoles.includes(role)
    ) {
      navigate("/admin/Unauthorized", {
        replace: true,
      });
      return;
    }
  }, [role, allowedRoles, navigate]);

  return <>{children}</>;
}